// extracted by mini-css-extract-plugin
export default {"pillWeb":"style_pillWeb__t-GXa","selected":"style_selected__gO+hx","disabled":"style_disabled__YFfOY","interactive":"style_interactive__uMMee","label":"style_label__eKkXL"};